export default function LackingPermissionPage() {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 text-center px-4">
            <h1 className="text-3xl font-semibold text-gray-800 mb-4">
                Access Denied
            </h1>
            <p className="text-gray-600 mb-6">
                You don’t have the necessary permissions to view this page.
            </p>
            <a
                href="/"
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
            >
                Go to Home
            </a>
        </div>
    );
}

